<template>
  <div>
    <v-data-table
      :single-select="true"
      item-key="id"
      :show-select="select"
      :headers="headers || []"
      :items="items || []"
      :search="search"
      :locale="'ru'"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      dense
      hide-default-footer
      class="customers-table elevation-0"
      @page-count="pageCount = $event"
    >
      <template v-if="select" #item.data-table-select="{ item }">
        <v-radio-group v-model="selected" hide-details class="mt-0">
          <v-radio
            :class="{
              'radio-ps': item.type === 'ps',
              'radio-company': item.type === 'company'
            }"
            :value="item.id"
            :color="item.type === 'company' ? 'red' : 'blue'"
            @change="changeCompany(item.id, item.name)"
          />
        </v-radio-group>
      </template>

      <template #item.name="{ item }">
        <b
          @click="onCompanyTitleClick(item)"
          class="pa-0 company-button"
          style="display: inline-block; cursor: pointer; letter-spacing: 0; line-height: 1.4; width: 250px"
          >{{ item.name }}</b
        >
      </template>

      <template #item.create_deal="{ item }">
        <v-btn
          @click="$emit('open-create-lead-dialog', item)"
          small
          depressed
          outlined
          color="primary"
          >{{ mess.dialog_create_lead_open_button }}</v-btn
        >
      </template>

      <template #item.ib="{ item }">
        <a
          href="/personal/my_customers/installations_maintenance/"
          target="_blank"
          style="color: #000; text-decoration: none"
          ><b>{{ item.ib }}</b></a
        >
      </template>

      <template #item.cp="{ item }">
        <a
          href="/personal/my_customers/installations_maintenance/"
          target="_blank"
          style="text-decoration: none"
          ><b :style="{ color: siteColors.primary }">{{ item.cp }}</b></a
        >
      </template>

      <template #item.mve="{ item }">
        <b :style="{ color: siteColors.primary }">{{ item.mve }}</b>
      </template>

      <template #item.cp_mve="{ item }">
        <b>{{ item.cp_mve }}</b>
      </template>

      <template #item.deals="{ item }">
        <v-btn
          tag="a"
          :href="item.deals_url"
          target="_blank"
          small
          outlined
          color="#9c9c9c"
          width="28"
          height="28"
          min-width="28"
          >{{ item.deals }}</v-btn
        >
      </template>

      <template #item.wishlists="{ item }">
        <b>{{ item.wishlists }}</b>
      </template>

      <template #item.requests="{ item }">
        <b>{{ item.requests }}</b>
      </template>
    </v-data-table>

    <div class="text-center pt-5">
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="total"
      />
    </div>
  </div>
</template>

<script>
// Services
import { companiesService } from "@/services/companies-service";

export default {
  name: "CustomersTable",
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 10
    },
    itemsPerPage: {
      type: Number,
      default: 20
    },
    search: {
      type: String,
      default: undefined
    },
    select: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update-company"],
  data() {
    return {
      page: 1,
      pageCount: 0,
      selected: -1
    };
  },
  watch: {
    selected(val) {
      const currentItem = this.items?.find(item => item.id === val);
      if (!this.items || !currentItem) return;

      this.$store.dispatch("setSelectedCustomer", currentItem);
      this.$emit("show-customer-card");
    },
    selectedCustomerId(val) {
      this.selected = val;
    }
  },
  methods: {
    changeCompany(id, name) {
      companiesService
        .setActiveCompany(id, name)
        .then(() => this.$emit("change-company", { id, name }));
    },
    onCompanyTitleClick({ id, name }) {
      this.$emit("open-company-info-dialog", { id, name });
      this.selected = id;
      setTimeout(() => this.changeCompany(id, name), 0);
    }
  },
  computed: {
    selectedCustomerId() {
      return this.$store.getters.selectedCustomer.id;
    }
  }
};
</script>

<style lang="scss">
.customers-table.v-data-table {
  thead tr {
    vertical-align: baseline;
    line-height: 1;
  }

  td {
    min-height: 26px;

    @media (min-width: 600px) {
      height: 60px !important;
    }
  }

  th {
    padding-top: 8px;
    padding-bottom: 8px;
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 500;
    line-height: 1.4;
    color: #9c9c9c;
  }

  .v-radio {
    margin-right: 0;
  }

  .v-input--selection-controls {
    padding-top: 0;
  }
}

.company-button {
  color: #1a1a1a;
  transition: color 250ms;

  &:hover {
    color: var(--v-primary-base);
  }
}

.v-pagination__item {
  outline: none;
  box-shadow: none;
  border: 1px solid #9c9c9c;
}

.v-pagination__navigation {
  outline: none;
  box-shadow: none;
  border: 1px solid #9c9c9c;
}

.radio-ps .v-icon.mdi-radiobox-blank {
  color: #2096f4;
}

.radio-company .v-icon.mdi-radiobox-blank {
  color: #f44335;
}
</style>
